module.exports = __webpack_public_path__ + "img/05.6238f141.jpg";